import { Button, Tag, TaskCard } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

import { useEmailVerificationResend } from "../../hooks/email-verification";

import { MESSAGES } from "./message-definitions";

export type EmailVerificationCardProps = {
  emailVerified: boolean;
  email: string;
};

export const EmailVerificationCard = ({ emailVerified, email }: EmailVerificationCardProps) => {
  if (emailVerified) {
    return <CompletedEmailVerificationCard />;
  }
  return <ActiveEmailVerificationCard emailAddress={email} />;
};

const CompletedEmailVerificationCard = () => {
  const intl = useIntl();
  return (
    <TaskCard
      taskUniqueId={MESSAGES.emailVerificationTitle.id}
      isCompleted={true}
      title={intl.formatMessage(MESSAGES.emailVerificationTitle)}
      slots={{
        end: <Tag color="positive" content={intl.formatMessage(MESSAGES.completedTag)} />,
      }}
    />
  );
};

const ActiveEmailVerificationCard = ({ emailAddress }: { emailAddress: string }) => {
  const intl = useIntl();
  const { sendVerificationEmail, isSending, recentlySent } = useEmailVerificationResend();
  const buttonDisabled = isSending || recentlySent;

  return (
    <TaskCard
      taskUniqueId={MESSAGES.emailVerificationTitle.id}
      isCompleted={false}
      title={intl.formatMessage(MESSAGES.emailVerificationTitle)}
      subtitle={{
        description: intl.formatMessage(MESSAGES.emailVerificationDescription, { emailAddress }),
        subtext: intl.formatMessage(MESSAGES.emailVerificationSubtext),
      }}
      slots={{
        end: (
          <Button variant="Tertiary" onClick={sendVerificationEmail} disabled={buttonDisabled}>
            {intl.formatMessage(recentlySent ? MESSAGES.emailVerificationCtaSent : MESSAGES.emailVerificationCta)}
          </Button>
        ),
      }}
    />
  );
};
